export const copyTextToClipBoard = (textToCopy: string) => {
    return navigator.clipboard.writeText(textToCopy);
}